/*import Badget_Icon from "../../common/assets/icon-magic.svg";
import Icvc from "../../common/assets/icvc.png";*/

const Badget_Icon = "/documents/d/guest/icon-magic";
const Icvc = "/documents/d/guest/icvc";

interface CardProps {
    planId: number;
    insureFromContract: string;
    producType: string;
    contractNumber: string;
    client: string;
    onClick: () => void;
}

const ContractCard = (card: CardProps ) => {
    return (
        <div className="card-v4">
            <div className="badget is-neutral">
                <img src={Badget_Icon} loading="lazy" alt="" className="badget_icon" />
                <div>Vigente desde {card.insureFromContract}</div>
            </div>
            <div className="perfil-i_textotarjet">
                <div className="perfil-i_textotile">{card.producType}</div>
                <div>Contrato: {card.contractNumber}</div>
            </div>
            <div>
                <span><strong>Contratante</strong></span>: {card.client}
            </div>
            <a onClick={card.onClick} className="button is-icon is-textob w-inline-block">
                <div>Ver detalle</div>
                <img src={Icvc} loading="lazy" alt="" />
            </a>
        </div>
    );
}
export default ContractCard;